<template>
  <section>
    <h2 class="text-xl md:text-2xl font-bold mb-4 md:mb-6">个人中心</h2>

    <div v-if="loading" class="bg-white rounded-lg p-6 mb-6 border border-gray-200 shadow-sm text-center text-textSub">
      加载中…
    </div>
    <template v-else-if="accountInfo">
      <div class="bg-white rounded-lg p-6 mb-6 border border-gray-200 shadow-sm">
        <div class="flex items-center gap-4 mb-6">
          <div
            class="w-16 h-16 rounded-full flex items-center justify-center text-white overflow-hidden border border-gray-200 shrink-0 relative"
            :class="showAvatarImg ? '' : 'bg-primary'"
          >
            <img
              v-if="showAvatarImg"
              :src="avatarDisplaySrc"
              class="absolute inset-0 w-full h-full object-cover pointer-events-none"
              alt=""
              referrerpolicy="no-referrer"
              @error="onAvatarLoadError"
            >
            <i v-else class="fa-solid fa-user text-3xl relative z-[1]"></i>
          </div>
          <div>
            <h3 class="text-xl font-semibold">{{ displayNickname }}</h3>
            <p class="text-textSub">账号ID：{{ accountInfo.userId }}</p>
          </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="bg-gray-50 rounded-md p-4 border border-gray-200">
            <p class="text-textSub mb-2">账户余额</p>
            <p class="text-xl font-semibold">¥ {{ (accountInfo.balance != null && accountInfo.balance !== '') ? accountInfo.balance : '0.00' }} 创作点</p>
          </div>
          <div class="bg-gray-50 rounded-md p-4 border border-gray-200">
            <p class="text-textSub mb-2">会员到期时间</p>
            <p class="text-xl font-semibold">{{ accountInfo.memberExpireTime || '非会员' }}</p>
          </div>
        </div>
      </div>

      <div class="bg-white rounded-lg p-6 mb-6 border border-gray-200 shadow-sm">
        <h3 class="text-xl font-semibold mb-4">我的资产</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div class="bg-gray-50 rounded-md p-4 border border-gray-200">
            <div class="flex items-center gap-2 mb-2">
              <i class="fa-solid fa-book-open text-primary"></i>
              <h4 class="font-medium">短篇小说</h4>
            </div>
            <p class="text-xl font-semibold">{{ accountInfo.shortNovelCount != null && accountInfo.shortNovelCount !== '' ? accountInfo.shortNovelCount : '0' }} 篇</p>
            <button class="mt-2 text-primary text-sm btn-hover" @click="$emit('open-view-all', 'short-novel')">查看全部</button>
          </div>
          <div class="bg-gray-50 rounded-md p-4 border border-gray-200" style="display: none;">
            <div class="flex items-center gap-2 mb-2">
              <i class="fa-solid fa-book text-primary"></i>
              <h4 class="font-medium">长篇小说</h4>
            </div>
            <p class="text-xl font-semibold">{{ accountInfo.longNovelCount != null && accountInfo.longNovelCount !== '' ? accountInfo.longNovelCount : '0' }} 篇</p>
            <button class="mt-2 text-primary text-sm btn-hover" @click="$emit('open-view-all', 'long-novel')">查看全部</button>
          </div>
          <div class="bg-gray-50 rounded-md p-4 border border-gray-200">
            <div class="flex items-center gap-2 mb-2">
              <i class="fa-solid fa-lightbulb text-primary"></i>
              <h4 class="font-medium">核心梗提取</h4>
            </div>
            <p class="text-xl font-semibold">{{ accountInfo.coreIdeaCount != null && accountInfo.coreIdeaCount !== '' ? accountInfo.coreIdeaCount : '0' }} 条</p>
            <button class="mt-2 text-primary text-sm btn-hover" @click="$emit('open-view-all', 'core-idea')">查看全部</button>
          </div>
          <div class="bg-gray-50 rounded-md p-4 border border-gray-200">
            <div class="flex items-center gap-2 mb-2">
              <i class="fa-solid fa-list text-primary"></i>
              <h4 class="font-medium">大纲提取</h4>
            </div>
            <p class="text-xl font-semibold">{{ accountInfo.outlineSectionCount != null && accountInfo.outlineSectionCount !== '' ? accountInfo.outlineSectionCount : '0' }} 份</p>
            <button class="mt-2 text-primary text-sm btn-hover" @click="$emit('open-view-all', 'outline')">查看全部</button>
          </div>
        </div>

        <div class="mt-6">
          <h4 class="font-medium mb-3">最近生成记录</h4>
          <div class="overflow-x-auto">
            <table class="w-full">
              <thead>
                <tr class="bg-gray-50 border-b border-gray-200">
                  <th class="py-2 px-3 text-left text-textSub text-sm">类型</th>
                  <th class="py-2 px-3 text-left text-textSub text-sm">标题</th>
                  <th class="py-2 px-3 text-left text-textSub text-sm">生成时间</th>
                  <th class="py-2 px-3 text-left text-textSub text-sm">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in novelHisLogList" :key="index" class="border-b border-gray-200 hover:bg-gray-50">
                  <td class="py-2 px-3 text-sm">{{ typeName(row.type) }}</td>
                  <td class="py-2 px-3 text-sm">{{ row.name }}</td>
                  <td class="py-2 px-3 text-sm text-textSub">{{ row.date }}</td>
                  <td class="py-2 px-3 text-sm">
                    <button class="text-primary btn-hover" @click="handleViewTask(row)">查看</button>
                  </td>
                </tr>
                <tr v-if="novelHisLogList.length === 0">
                  <td colspan="4" class="py-4 px-3 text-center text-textSub text-sm">暂无记录</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="bg-white rounded-lg p-6 border border-gray-200 shadow-sm">
        <h3 class="text-lg font-semibold mb-4">账户设置</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label class="block text-textSub mb-2">绑定手机号</label>
            <input type="text" class="w-full bg-white rounded-md p-3 focus:outline-none focus:ring-1 focus:ring-primary border border-gray-200" :value="accountInfo.phone || ''" readonly placeholder="未绑定">
          </div>
          <div>
            <label class="block text-textSub mb-2">简书账号</label>
            <input type="text" class="w-full bg-white rounded-md p-3 focus:outline-none focus:ring-1 focus:ring-primary border border-gray-200" :value="accountInfo.slug || ''" readonly placeholder="未绑定">
          </div>
		  <!-- <div>
		    <label class="block text-textSub mb-2">微信绑定</label>
		    <input type="text" class="w-full bg-white rounded-md p-3 focus:outline-none focus:ring-1 focus:ring-primary border border-gray-200" :value="accountInfo.wechat || ''" readonly placeholder="未绑定">
		  </div>
		  <div>
		    <label class="block text-textSub mb-2">QQ账号</label>
		    <input type="text" class="w-full bg-white rounded-md p-3 focus:outline-none focus:ring-1 focus:ring-primary border border-gray-200" :value="accountInfo.qq || ''" readonly placeholder="未绑定">
		  </div> -->
        </div>
        <div class="mt-6 flex gap-4">
          <!-- <button class="bg-white border border-primary text-primary py-2 px-4 rounded-md btn-hover" @click="$emit('show-modal', '提示', '功能开发中')">修改密码</button> -->
          <button class="bg-white border border-primary text-primary py-2 px-4 rounded-md btn-hover" @click="openInvoiceModal">开具发票</button>
          <button class="bg-red-500 text-white py-2 px-4 rounded-md btn-hover" @click="$emit('cancel-account')">账户注销</button>
        </div>
      </div>
    </template>
    <div v-else class="bg-white rounded-lg p-6 mb-6 border border-gray-200 shadow-sm text-center text-textSub">
      暂无账户信息
    </div>

    <!-- 开具发票弹层：步骤一 抬头+邮箱，步骤二 分页多选列表 + 提交 -->
    <div
      v-show="invoiceModal.visible"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      @click.self="closeInvoiceModal"
    >
      <div class="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col border border-gray-200 shadow-lg mx-4">
        <div class="flex justify-between items-center mb-4 flex-shrink-0">
          <h3 class="text-xl font-semibold">开具发票</h3>
          <button class="text-textSub text-xl cursor-pointer" @click="closeInvoiceModal">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <!-- 步骤一：抬头、邮箱 -->
        <template v-if="invoiceModal.step === 1">
          <div class="mb-4">
            <label class="block text-sm text-textSub mb-1">发票抬头</label>
            <input
              v-model="invoiceModal.title"
              type="text"
              class="w-full border border-gray-200 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-primary"
              placeholder="请输入发票抬头"
            >
          </div>
          <div class="mb-4">
            <label class="block text-sm text-textSub mb-1">税号</label>
            <input
              v-model="invoiceModal.taxNo"
              type="text"
              class="w-full border border-gray-200 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-primary"
              placeholder="请输入纳税人识别号"
            >
          </div>
          <div class="mb-5">
            <label class="block text-sm text-textSub mb-1">邮箱地址</label>
            <input
              v-model="invoiceModal.email"
              type="email"
              class="w-full border border-gray-200 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-primary"
              placeholder="请输入接收发票的邮箱"
            >
          </div>
          <div class="flex justify-end">
            <button class="bg-primary text-white py-2 px-5 rounded-md btn-hover" @click="invoiceNextStep">下一步</button>
          </div>
        </template>

        <!-- 步骤二：分页多选列表 -->
        <template v-else>
          <div class="mb-3 text-sm text-textSub">请勾选需要开票的记录（可多选）</div>
          <div class="flex-1 overflow-auto border border-gray-200 rounded-md mb-4 min-h-[200px]">
            <table class="w-full">
              <thead class="bg-gray-50 border-b border-gray-200 sticky top-0">
                <tr>
                  <th class="py-2 px-3 text-left text-textSub text-sm w-10">
                    <input
                      type="checkbox"
                      :checked="invoiceSelectAll"
                      :indeterminate="invoiceSelectSome"
                      @change="toggleInvoiceSelectAll"
                    >
                  </th>
                  <th class="py-2 px-3 text-left text-textSub text-sm">序号</th>
                  <th class="py-2 px-3 text-left text-textSub text-sm">充值类别</th>
                  <th class="py-2 px-3 text-left text-textSub text-sm">订单金额</th>
                  <th class="py-2 px-3 text-left text-textSub text-sm">付款日期</th>
                  <th class="py-2 px-3 text-left text-textSub text-sm">发票状态</th>

                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in invoiceModal.list" :key="item.id || index" class="border-b border-gray-200 hover:bg-gray-50">
                  <td class="py-2 px-3">
                    <input
                      type="checkbox"
                      :checked="isInvoiceSelected(item)"
                      :disabled="!canSelectInvoiceItem(item)"
                      @change="toggleInvoiceItem(item)"
                    >
                  </td>
                  <td class="py-2 px-3 text-sm text-textSub">{{ (invoiceModal.currentPage - 1) * invoiceModal.pageSize + index + 1 }}</td>
                  <td class="py-2 px-3 text-sm text-textSub">{{ invoiceGoodTypeText(item.goodType) }}</td>
                  <td class="py-2 px-3 text-sm">{{ formatInvoiceAmount(item.orderAmount) }}</td>
                  <td class="py-2 px-3 text-sm text-textSub">{{ item.payDate}}</td>
                  <td class="py-2 px-3 text-sm">{{ formatInvoiceStatusText(item.invoiceStatus) }}</td>

                </tr>
                <tr v-if="invoiceModal.list.length === 0 && !invoiceListLoading">
                  <td colspan="7" class="py-6 text-center text-textSub text-sm">暂无可开票记录</td>
                </tr>
                <tr v-if="invoiceListLoading">
                  <td colspan="7" class="py-6 text-center text-textSub text-sm">加载中…</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="flex items-center justify-between flex-shrink-0 px-4 py-3 border-t border-gray-200 bg-gray-50 rounded-b-md">
            <div class="text-sm text-textSub">
              已选 {{ invoiceModal.selectedIds.length }} 条 · 第 {{ invoiceModal.currentPage }} 页
            </div>
            <div class="space-x-2">
              <button
                class="px-3 py-1 rounded border text-sm btn-hover"
                :class="invoiceModal.currentPage <= 1 ? 'border-gray-200 text-gray-300 cursor-not-allowed' : 'border-gray-300 text-textMain'"
                :disabled="invoiceModal.currentPage <= 1"
                @click="invoiceChangePage(invoiceModal.currentPage - 1)"
              >
                上一页
              </button>
              <button
                class="px-3 py-1 rounded border text-sm btn-hover"
                :class="!invoiceModal.hasMore ? 'border-gray-200 text-gray-300 cursor-not-allowed' : 'border-gray-300 text-textMain'"
                :disabled="!invoiceModal.hasMore"
                @click="invoiceChangePage(invoiceModal.currentPage + 1)"
              >
                下一页
              </button>
            </div>
          </div>
          <div class="flex gap-3 mt-4">
            <button class="flex-1 border border-gray-300 text-textMain py-2 rounded-md btn-hover" @click="invoiceModal.step = 1">上一步</button>
            <button
              class="flex-1 bg-primary text-white py-2 rounded-md btn-hover"
              :disabled="invoiceSubmitting"
              @click="submitInvoice"
            >
              {{ invoiceSubmitting ? '提交中...' : '提交' }}
            </button>
          </div>
        </template>
      </div>
    </div>

    <!-- 任务查看：正文弹窗 -->
    <div
      v-show="taskViewModal.visible"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      @click.self="closeTaskViewModal"
    >
      <div class="bg-white rounded-lg p-6 w-full max-w-3xl max-h-[90vh] overflow-auto border border-gray-200 shadow-lg mx-4">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-xl font-semibold">{{ taskViewModal.title }}</h3>
          <button class="text-textSub text-xl cursor-pointer" @click="closeTaskViewModal">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div class="text-textSub whitespace-pre-line">{{ taskViewModal.text }}</div>
      </div>
    </div>

    <!-- 任务查看：进度浮层（同 ShortNovel 风格） -->
    <div
      v-show="taskProgressModal.visible"
      class="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
      @click.self="closeTaskProgressModal"
    >
      <div class="bg-white rounded-lg px-6 py-5 shadow-md border border-gray-200 max-w-sm w-full mx-4">
        <div class="flex items-center justify-center gap-2 mb-4">
          <i class="fa-solid fa-spinner fa-spin text-primary"></i>
          <div class="text-primary text-lg font-semibold">任务进行中...</div>
        </div>
        <div class="space-y-2 text-sm">
          <div
            v-for="(s, idx) in taskProgressSteps"
            :key="s.key"
            class="flex items-start gap-2 text-textMain"
          >
            <div class="mt-0.5">
              <i
                v-if="getTaskStepStatus(idx) === 'FAILED'"
                class="fa-solid fa-circle-xmark text-red-500"
              ></i>
              <i
                v-else-if="getTaskStepStatus(idx) === 'SUCCESS'"
                class="fa-solid fa-circle-check text-green-500"
              ></i>
              <i
                v-else
                class="fa-solid fa-circle text-gray-300"
              ></i>
            </div>
            <div class="flex-1">
              <div class="grid grid-cols-[1fr_12rem] items-center gap-3 leading-6">
                <span class="font-medium">{{ s.label }}</span>
                <span class="text-textSub whitespace-nowrap text-right">预计{{ s.etaMin }}分钟，请耐心等待</span>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4 flex gap-3">
          <button
            class="flex-1 border border-gray-300 text-textMain py-2 rounded-md btn-hover"
            type="button"
            @click="closeTaskProgressModal"
          >
            关闭
          </button>
          <button
            class="flex-1 bg-primary text-white py-2 rounded-md btn-hover"
            :class="(taskProgressModal.refreshing || taskProgressModal.cooldownLeft > 0) ? 'cursor-not-allowed opacity-70' : 'cursor-pointer'"
            type="button"
            :disabled="taskProgressModal.refreshing || taskProgressModal.cooldownLeft > 0"
            @click="refreshTaskProgress"
          >
            {{
              taskProgressModal.refreshing
                ? '刷新中...'
                : (taskProgressModal.cooldownLeft > 0 ? ('刷新状态（' + taskProgressModal.cooldownLeft + 's）') : '刷新状态')
            }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getMemberAccount } from '../api/member'
import { getInvoiceList, submitInvoice as submitInvoiceApi } from '../api/invoice'
import { queryShortNovelTask } from '../api/shortNovel'
import { useAuthState } from '../store/auth'

const TYPE_MAP = {
  '1': '短篇小说',
  '2': '长篇小说',
  '3': '核心梗',
  '4': '大纲提取'
}

export default {
  name: 'ProfileSection',
  props: {
    workData: { type: Object, default: () => ({}) },
    active: { type: Boolean, default: false }
  },
  data () {
    return {
      loading: false,
      accountInfo: null,
      novelHisLogList: [],
      taskViewModal: {
        visible: false,
        title: '查看',
        text: ''
      },
      taskProgressModal: {
        visible: false,
        taskId: '',
        lastResult: null,
        refreshing: false,
        cooldownLeft: 0,
        cooldownTimer: null
      },
      invoiceModal: {
        visible: false,
        step: 1,
        title: '',
        taxNo: '',
        email: '',
        list: [],
        total: 0,
        currentPage: 1,
        pageSize: 5,
        hasMore: true,
        selectedIds: []
      },
      invoiceListLoading: false,
      invoiceSubmitting: false,
      avatarLoadError: false
    }
  },
  computed: {
    /** 与 AppHeader 同源：登录态下由 checkLogin 写入 store */
    authState () {
      return useAuthState()
    },
    displayNickname () {
      var n = (this.authState.nickname || '').trim()
      return n || '用户'
    },
    hasUsableAvatarSrc () {
      return this.isUsableAvatarSrc(this.authState.avatar)
    },
    avatarDisplaySrc () {
      if (!this.hasUsableAvatarSrc) return ''
      return (this.authState.avatar || '').trim()
    },
    showAvatarImg () {
      return this.hasUsableAvatarSrc && !this.avatarLoadError
    },
    taskProgressSteps () {
      return [
        { key: '1', label: '梳理小说大纲', etaMin: 1 },
        { key: '2', label: '行文模板匹配', etaMin: 1 },
        { key: '3', label: '生成小说', etaMin: 4 },
        { key: '4', label: '生成导语', etaMin: 1 }
      ]
    },
    invoiceSelectAll () {
      var list = this.invoiceModal.list
      var selectable = list.filter(function (item) { return this.canSelectInvoiceItem(item) }, this)
      if (!selectable.length) return false
      return selectable.every(function (item) {
        return this.invoiceModal.selectedIds.indexOf(item.id) !== -1
      }, this)
    },
    invoiceSelectSome () {
      var list = this.invoiceModal.list
      var selectable = list.filter(function (item) { return this.canSelectInvoiceItem(item) }, this)
      if (!selectable.length) return false
      var selected = this.invoiceModal.selectedIds
      var n = selectable.filter(function (item) { return selected.indexOf(item.id) !== -1 }).length
      return n > 0 && n < selectable.length
    }
  },
  mounted () {
    if (this.active) this.fetchAccount()
  },
  watch: {
    active (val) {
      if (val) this.fetchAccount()
    },
    'authState.avatar' () {
      this.avatarLoadError = false
    }
  },
  methods: {
    isUsableAvatarSrc (value) {
      var s = value != null ? String(value).trim() : ''
      if (!s) return false
      var lower = s.toLowerCase()
      if (lower.indexOf('http://') === 0 || lower.indexOf('https://') === 0) return true
      if (lower.indexOf('//') === 0) return true
      if (s.charAt(0) === '/') return true
      if (lower.indexOf('data:image/') === 0) return true
      return false
    },
    onAvatarLoadError () {
      this.avatarLoadError = true
    },
    typeName (type) {
      return TYPE_MAP[String(type)] || '其他'
    },
    async fetchAccount () {
      this.loading = true
      try {
        const res = await getMemberAccount()
        this.loading = false
        if (res) {
          this.accountInfo = res.memberAccountInfo
          this.novelHisLogList = res.novelHisLogList || []
        }
      } catch (err) {
        this.loading = false
      }
    },
    normalizeTaskResult (raw) {
      // request 拦截器一般会把外层 data 剥掉，但这里仍做兼容
      if (!raw) return {}
      if (raw && raw.data && typeof raw.taskStatus === 'undefined') return raw.data
      return raw
    },
    extractTaskText (raw) {
      const res = this.normalizeTaskResult(raw)
      // 兼容多种字段：text/content 以及嵌套 data
      const txt = (res && (res.text != null ? res.text : (res.content != null ? res.content : ''))) || ''
      return typeof txt === 'string' ? txt : String(txt)
    },
    extractTaskStatus (raw) {
      const res = this.normalizeTaskResult(raw)
      return res && res.taskStatus ? String(res.taskStatus) : ''
    },
    getTaskStepStatus (idx) {
      const res = this.normalizeTaskResult(this.taskProgressModal.lastResult)
      if (!res) return ''
      const n = idx + 1
      const statusKey = 'step_' + n + '_status'
      const direct = res && res[statusKey]
      if (direct === 'SUCCESS' || direct === 'FAILED') return direct
      const progress = res && res.taskProgress
      if (typeof progress === 'string' && progress.indexOf('=') > -1) {
        const parts = progress.split('=').map(s => s.trim())
        if (parts[0] === String(n) && (parts[1] === 'SUCCESS' || parts[1] === 'FAILED')) return parts[1]
      }
      return ''
    },
    closeTaskViewModal () {
      this.taskViewModal.visible = false
      this.taskViewModal.title = '查看'
      this.taskViewModal.text = ''
    },
    closeTaskProgressModal () {
      this.taskProgressModal.visible = false
      this.taskProgressModal.taskId = ''
      this.taskProgressModal.lastResult = null
      this.taskProgressModal.refreshing = false
      this.stopTaskCooldown()
      this.taskProgressModal.cooldownLeft = 0
    },
    stopTaskCooldown () {
      if (this.taskProgressModal.cooldownTimer) {
        clearInterval(this.taskProgressModal.cooldownTimer)
        this.taskProgressModal.cooldownTimer = null
      }
    },
    startTaskCooldown (seconds) {
      this.stopTaskCooldown()
      this.taskProgressModal.cooldownLeft = typeof seconds === 'number' ? seconds : 10
      this.taskProgressModal.cooldownTimer = setInterval(() => {
        if (!this.taskProgressModal.visible) {
          this.stopTaskCooldown()
          return
        }
        if (this.taskProgressModal.cooldownLeft <= 1) {
          this.taskProgressModal.cooldownLeft = 0
          this.stopTaskCooldown()
        } else {
          this.taskProgressModal.cooldownLeft = this.taskProgressModal.cooldownLeft - 1
        }
      }, 1000)
    },
    async refreshTaskProgress () {
      const taskId = this.taskProgressModal.taskId
      if (!this.taskProgressModal.visible || !taskId) return
      if (this.taskProgressModal.refreshing) return
      if (this.taskProgressModal.cooldownLeft > 0) return
      this.taskProgressModal.refreshing = true
      try {
        const raw = await queryShortNovelTask(taskId)
        this.taskProgressModal.lastResult = raw || null
        const status = this.extractTaskStatus(raw)
        if (status === 'SUCCESS') {
          this.taskProgressModal.visible = false
          this.taskViewModal = {
            visible: true,
            title: '创作内容',
            text: this.extractTaskText(raw)
          }
        } else if (status === 'FAILED') {
          this.taskProgressModal.visible = false
          this.$emit('show-modal', '任务失败', '任务失败')
        }
      } catch (err) {
        const msg = (err && err.message) || '查询失败，请稍后重试。'
        this.$emit('show-modal', '提示', msg)
      } finally {
        this.taskProgressModal.refreshing = false
        if (this.taskProgressModal.visible) {
          this.startTaskCooldown(10)
        }
      }
    },
    async handleViewTask (row) {
      const taskId = row && row.taskId != null ? String(row.taskId) : ''
      if (!taskId) {
        this.$emit('show-modal', '提示', '缺少任务ID，无法查看。')
        return
      }
      try {
        const raw = await queryShortNovelTask(taskId)
        const status = this.extractTaskStatus(raw)
        if (status === 'SUCCESS') {
          this.taskViewModal = {
            visible: true,
            title: '创作内容',
            text: this.extractTaskText(raw)
          }
          return
        }
        if (status === 'FAILED') {
          this.$emit('show-modal', '任务失败', '任务失败')
          return
        }
        if (status === 'PROCESSING') {
          this.taskProgressModal.visible = true
          this.taskProgressModal.taskId = taskId
          this.taskProgressModal.lastResult = raw || null
          this.startTaskCooldown(10)
          return
        }
        // 兜底：未知状态也当作进行中展示
        this.taskProgressModal.visible = true
        this.taskProgressModal.taskId = taskId
        this.taskProgressModal.lastResult = raw || null
        this.startTaskCooldown(10)
      } catch (err) {
        const msg = (err && err.message) || '查询失败，请稍后重试。'
        this.$emit('show-modal', '提示', msg)
      }
    },
    openInvoiceModal () {
      this.invoiceModal.visible = true
      this.invoiceModal.step = 1
      this.invoiceModal.title = ''
      this.invoiceModal.taxNo = ''
      this.invoiceModal.email = ''
      this.invoiceModal.list = []
      this.invoiceModal.total = 0
      this.invoiceModal.currentPage = 1
      this.invoiceModal.hasMore = true
      this.invoiceModal.selectedIds = []
    },
    closeInvoiceModal () {
      this.invoiceModal.visible = false
    },
    invoiceNextStep () {
      var title = (this.invoiceModal.title || '').trim()
      var taxNo = (this.invoiceModal.taxNo || '').trim()
      var email = (this.invoiceModal.email || '').trim()
      if (!title) {
        this.$emit('show-modal', '提示', '请输入发票抬头。')
        return
      }
      if (!taxNo) {
        this.$emit('show-modal', '提示', '请输入税号。')
        return
      }
      if (!email) {
        this.$emit('show-modal', '提示', '请输入邮箱地址。')
        return
      }
      this.invoiceModal.step = 2
      this.fetchInvoiceList(1)
    },
    async fetchInvoiceList (page) {
      if (typeof page === 'number' && page > 0) {
        this.invoiceModal.currentPage = page
      }
      const fromIndex = this.invoiceModal.currentPage
      this.invoiceListLoading = true
      try {
        const res = await getInvoiceList(fromIndex, this.invoiceModal.pageSize)
        const list = res && Array.isArray(res.list) ? res.list : []
        const total = res && typeof res.total === 'number' ? res.total : list.length
        this.invoiceListLoading = false
        this.invoiceModal.list = list
        this.invoiceModal.total = total
        this.invoiceModal.hasMore = this.invoiceModal.currentPage * this.invoiceModal.pageSize < total
      } catch (err) {
        this.invoiceListLoading = false
        this.invoiceModal.list = []
        this.invoiceModal.total = 0
        this.invoiceModal.hasMore = false
      }
    },
    invoiceChangePage (page) {
      if (page < 1) return
      if (!this.invoiceModal.hasMore && page > this.invoiceModal.currentPage) return
      this.fetchInvoiceList(page)
    },
    invoiceGoodTypeText (goodType) {
      var map = { '1': '会员购买', '2': '点数充值' }
      return map[String(goodType)] || '-'
    },
    formatInvoiceAmount (v) {
      if (v == null || v === '') return '-'
      var n = parseFloat(v)
      if (isNaN(n)) return '-'
      return '¥ ' + n.toFixed(2)
    },
    formatInvoiceStatusText (invoiceStatus) {
      var map = {'0':'未开具', '1': '开具中', '2': '开具完成' }
      return map[String(invoiceStatus)] || '-'
    },
    canSelectInvoiceItem (item) {
      return item.invoiceStatus === 0 || item.invoiceStatus === '0'
    },
    isInvoiceSelected (item) {
      return this.invoiceModal.selectedIds.indexOf(item.id) !== -1
    },
    toggleInvoiceItem (item) {
      if (!this.canSelectInvoiceItem(item)) return
      var id = item.id
      var idx = this.invoiceModal.selectedIds.indexOf(id)
      if (idx === -1) {
        this.invoiceModal.selectedIds = this.invoiceModal.selectedIds.concat([id])
      } else {
        this.invoiceModal.selectedIds = this.invoiceModal.selectedIds.slice(0, idx).concat(this.invoiceModal.selectedIds.slice(idx + 1))
      }
    },
    toggleInvoiceSelectAll () {
      var list = this.invoiceModal.list
      var selected = this.invoiceModal.selectedIds
      var selectableIds = list.filter(function (item) { return this.canSelectInvoiceItem(item) }, this).map(function (item) { return item.id })
      var allSelected = selectableIds.length && selectableIds.every(function (id) { return selected.indexOf(id) !== -1 })
      if (allSelected) {
        this.invoiceModal.selectedIds = selected.filter(function (id) { return selectableIds.indexOf(id) === -1 })
      } else {
        var combined = selected.slice()
        selectableIds.forEach(function (id) {
          if (combined.indexOf(id) === -1) combined.push(id)
        })
        this.invoiceModal.selectedIds = combined
      }
    },
    async submitInvoice () {
      if (this.invoiceModal.selectedIds.length === 0) {
        this.$emit('show-modal', '提示', '请至少选择一条记录。')
        return
      }
      this.invoiceSubmitting = true
      const payload = {
        title: (this.invoiceModal.title || '').trim(),
        taxNo: (this.invoiceModal.taxNo || '').trim(),
        email: (this.invoiceModal.email || '').trim(),
        ids: this.invoiceModal.selectedIds
      }
      try {
        await submitInvoiceApi(payload)
        this.invoiceSubmitting = false
        this.closeInvoiceModal()
        this.$emit('show-modal', '开具发票', '发票申请已提交，请查收邮件。')
      } catch (err) {
        this.invoiceSubmitting = false
        this.$emit('show-modal', '开具发票', '提交失败，请稍后重试。')
      }
    }
  }
}
</script>
